import * as React from 'react'

export function TabbarHomeNoCon(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M18.45 12.941l-1.234 6.078C17.1 19.59 16.591 20 16 20c-.59 0-1.1-.41-1.216-.98L13.55 12.94c-.31-1.52.873-2.94 2.45-2.94 1.577 0 2.76 1.42 2.45 2.94M16 25.001a1.501 1.501 0 11-.002-2.998A1.501 1.501 0 0116 25m11.663-10.809L16.708 4.278a1.044 1.044 0 00-1.416-.003L4.34 14.188c-.702.644-.245 1.812.707 1.812h1.966L7 27a1 1 0 001.001 1h15.984a1 1 0 001.001-1L25 16h1.953c.95 0 1.407-1.164.71-1.809'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
